import { gql } from "urql";

export const apiCostFiltersQuery = gql`
    query ApiCostFiltersQuery {
        modelList
        externalList {
            id
            name
        }
    }
`;

export const apiCostsMonthlyQuery = gql`
    query ApiCostsMonthlyQuery($model: String, $externalId: Int, $noExternal: Boolean) {
        apiCostsMonthly(model: $model, externalId: $externalId, noExternal: $noExternal) {
            year
            month
            cost
        }
    }
`;

export const apiCostsDailyQuery = gql`
    query ApiCostsDailyQuery($year: Int!, $month: Int!, $model: String, $externalId: Int, $noExternal: Boolean) {
        apiCostsDaily(year: $year, month: $month, model: $model, externalId: $externalId, noExternal: $noExternal) {
            year
            month
            day
            cost
        }
    }
`;

export const apiCostsDetailsQuery = gql`
    query ApiCostsDetailsQuery(
        $year: Int!,
        $month: Int!,
        $day: Int,
        $model: String,
        $externalId: Int,
        $noExternal: Boolean,
        $page: Int
    ) {
        apiCostsDetails(
            year: $year,
            month: $month,
            day: $day,
            model: $model,
            externalId: $externalId,
            noExternal: $noExternal,
            page: $page
        ) {
            maxPage
            items {
                id
                created
                cost
                model
                external {
                    id
                    name
                }
            }
        }
    }
`;

export type * from "./__generated__/api-cost-filters-query";
export type * from "./__generated__/api-costs-daily-query";
export type * from "./__generated__/api-costs-details-query";
export type * from "./__generated__/api-costs-monthly-query";
